export const cognitoConfig = {
  userPoolId: process.env.REACT_APP_AWS_COGNITO_USER_POOL_ID,
  clientId: process.env.REACT_APP_AWS_COGNITO_CLIENT_ID
};

export const apiConfig = {
  apiBaserl: process.env.REACT_APP_API_BASE_URL
};

export const mapsConfig = {
  apiKey: process.env.REACT_APP_MAPS_API_KEY
};

export const googleAnalyticsConfig = process.env.REACT_APP_GA_MEASUREMENT_ID;
